/**
 * Weak-Area Spotlight - dashboard card naming the member's weakest subject
 * with one-tap paths to fix it (lesson + targeted practice).
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target, BookOpen, Play } from "lucide-react";
import { api } from "@/App";

const FocusAreaCard = () => {
  const [focus, setFocus] = useState(null);

  useEffect(() => {
    api.get("/progress/focus-area")
      .then((d) => { if (d.has_focus) setFocus(d); })
      .catch(() => {});
  }, []);

  if (!focus) return null;

  return (
    <div
      data-testid="focus-area-card"
      className="rounded-2xl border border-warning/30 bg-warning/5 p-5 sm:p-6"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-warning/15 text-warning flex items-center justify-center flex-shrink-0">
            <Target className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <h3 className="font-semibold">
              Focus area: <span className="text-warning">{focus.subject_name}</span>
            </h3>
            <p className="text-sm text-muted-foreground mt-0.5">
              You're at <strong>{focus.accuracy}%</strong> accuracy over {focus.answered} questions - a
              focused session here moves your readiness score the most.
            </p>
          </div>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Link
            to={`/learn/${focus.subject_id}`}
            data-testid="focus-area-learn-btn"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-card text-sm font-medium hover:bg-muted"
          >
            <BookOpen className="w-4 h-4" /> Study it
          </Link>
          <Link
            to={`/practice/${focus.subject_id}`}
            data-testid="focus-area-practice-btn"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warning text-white text-sm font-medium hover:opacity-90"
          >
            <Play className="w-4 h-4" /> Practice it
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FocusAreaCard;
